import { Injectable } from '@angular/core';
import * as jwt from "jsonwebtoken";
import * as crypto from 'crypto-browserify'
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable,BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppService } from '@app/app.service';
declare var Buffer: any;
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  pvtkey;
  linkCode = "";
  private localKeys = {
    "language": "language",
    "gender": "gender",
    "chatInfo": "chatInfo",
    "countries": "countries",
    "packages": "packages",
    "dateFormat": "dateFormat"
  };
  public profilemImageChange = new BehaviorSubject < boolean > (false);
  profilemImageChangeObservable = this.profilemImageChange.asObservable();

  public profileDeatilsChange = new BehaviorSubject < boolean > (false);
  userDataChangeObservable = this.profileDeatilsChange.asObservable();
  ngt18Url: string = environment.API_URL+'netgateAPI/';
  constructor(private httpClient: HttpClient,private router: Router,private appService: AppService) {}
  createObject(data) {
    var object = {}
    if (!Array.prototype.forEach) {
      Array.prototype.forEach = function (fn, scope) {
        for (var i = 0, len = this.length; i < len; ++i) {
          fn.call(scope, this[i], i, this);
        }
      }
    }
    data.forEach(function (value, key) {
      object[key] = value;
    });
    return object;
  }
  createToken(data) {
    let cert;
    let privateKey = JSON.parse(atob( localStorage.getItem('bWV0YURhdGFDb25maWc='))).privateKey.key;
    let key = '';
    let begin = '-----BEGIN RSA PRIVATE KEY-----';
    let end = '-----END RSA PRIVATE KEY-----';
    while (privateKey.length > 0) {
      key += privateKey.substring(0, 64) + '\n';
      privateKey = privateKey.substring(64);
    }
    cert = `${begin}\n${key}${end}\n`;
    let paramsOption = {
      algorithm: 'RS256',
      expiresIn: 120
    };
    let token = jwt.sign(data, cert, paramsOption);
    // this.setCookie(this.encrypt(environment.USER_ACTIVE_CHECK), this.encrypt(new Date().toString()), 10000, environment.cookieDomain, '/')
    return token;
  }
  encrypt(data) {

    var binaryEncryptionKey = new Buffer(JSON.parse(atob( localStorage.getItem('bWV0YURhdGFDb25maWc='))).encryptionKey, "base64");
    var binaryIV = new Buffer(0);

    var cipher = crypto.createCipheriv("AES-128-ECB", binaryEncryptionKey, binaryIV);
    var encryptedInput = (
      cipher.update(data, "utf8", "base64") +
      cipher.final("base64")
    );
    return encryptedInput;
  }

  decrypt(data) {
    try {


      var binaryEncryptionKey = new Buffer(JSON.parse(atob( localStorage.getItem('bWV0YURhdGFDb25maWc='))).encryptionKey, "base64");
      var binaryIV = new Buffer(0);

      var decipher = crypto.createDecipheriv("AES-128-ECB", binaryEncryptionKey, binaryIV);
      var decryptedInput = (
        decipher.update(data, "base64", "utf8") +
        decipher.final("utf8")
      );
      return decryptedInput;
    } catch (error) {

      return '';
    }
  }
  getCurrentLanguageCode() {
    let currentLang = localStorage.getEncryptedItem("current_lang");
    let lang = "de";
    if (currentLang) {
      currentLang = JSON.parse(currentLang);
      lang = currentLang["key"];
    }
    return lang;
  }
  fetchLanguage(language) {
    let langData = this.getCommonDataOnLanuguage(language, this.localKeys.language);
    if (!langData || this.getCurrentLanguageCode() != language) {
        var formData = new FormData();
        formData.append('userId','');
        formData.append("loggedInTime", '');
        formData.append("lastRequestTime", '');
        return this.httpClient.post(this.ngt18Url + "core.standard.language&language=" + language, formData).pipe(map((res: Response) =>  {
            // res = res.json();
            if(!res.status && res["isUnauthenticated"]) {
                this.logout();                    
                return false;
            }
            localStorage.setEncryptedItem("lastRequestTime",res["RESPONSETIME"]);
            if (res["STATUS"]) {
                this.setCommonDataOnLanguage(language, this.localKeys.language, res["DATA"]);
            }
            return res["DATA"];
        }));
    } else {
        return new Observable((observable) => {
            observable.next(langData);
            observable.complete();
        });
    }
}
  getCommonDataOnLanuguage(language, key) {
    let commonData = localStorage.getEncryptedItem("common-data");
    let retData = null;
    if (commonData) {
      try {
        commonData = JSON.parse(commonData);
        let commonLangData = commonData[language];
        if (commonLangData && commonLangData[key]) {
          retData = commonLangData[key];
        }
      } catch (e) {
        retData = null;
        throw "Error in parsing commondata from localStorage";
      } finally {}
    }
    return retData;
  }
  setCommonDataOnLanguage(language, key, data) {
    let commonData: any = localStorage.getEncryptedItem("common-data");
    let langData;
    if (commonData) {
      commonData = JSON.parse(commonData);
      commonData[language] = commonData[language] || {};
      langData = commonData[language];
    } else {
      commonData = {};
      commonData[language] = {};
      langData = commonData[language];
    }
    langData[key] = data;
    localStorage.setEncryptedItem("common-data", JSON.stringify(commonData));
  }
  setLinkdInCode(LinkdInCode) {
    this.linkCode = LinkdInCode;
    if (this.linkCode != undefined) {
      return this.linkCode;
    } else {
      return "";
    }
  }
  changeDialogState(value: boolean) {
    this.profilemImageChange.next(value);
    //  this. profileDeatilsChange.next(value);
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  clearExpireCookie() {
    let data = localStorage.getItem('bWV0YURhdGFDb25maWc=');
    localStorage.clear();
    localStorage.setItem('bWV0YURhdGFDb25maWc=',data);
    (() => {
      let cookies = document.cookie.split("; ");
      for (let c = 0; c < cookies.length; c++) {
        if (cookies[c].split(";")[0].split("=")[0] == environment.checkCookie) {
          let d = window.location.hostname.split(".");
          while (d.length > 0) {
            let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            let p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
              document.cookie = cookieBase + p.join('/');
              p.pop();
            };
            d.shift();
          }
        }
      }
    })();
  }
  clearCookieStorage(hotReload = false) {
    (() => {
      let cookies = document.cookie.split("; ");
      for (let c = 0; c < cookies.length; c++) {
         const cookieName = cookies[c].split("=")[0];
         if (cookieName !== environment.cookieConsent && cookieName !== environment.instanceCookie) {
          let d = window.location.hostname.split(".");
          while (d.length > 0) {
            let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            let p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
              document.cookie = cookieBase + p.join('/');
              p.pop();
            };
            d.shift();
          }
        }
      }
    })();
    if (hotReload)  
        window.location.reload();
     
  }
  setCookie(name: string, value: any, expireDays: number, domain: string, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value};domain=${domain}; ${expires}${cpath};`;
  }
  logout() {
    let instance = localStorage.getItem('instance');
    let data = localStorage.getItem('bWV0YURhdGFDb25maWc=');
    // localStorage.clear();
    localStorage.setItem('bWV0YURhdGFDb25maWc=',data);
    // instance ?  window.location.href = 'http://'+instance+environment.domain+'/#/auth/logout/'+encodeURIComponent(this.encrypt(window.location.href)): this.router.navigate(['/unauthorized']);
    instance ?  window.location.href = 'https://'+instance+environment.domain+'/auth/logout/'+encodeURIComponent(this.encrypt(window.location.href)): this.router.navigate(['/unauthorized']);
  }
}